import React from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../AssetHelpers";
type Props = {
  className?: string;
  path: string;
  svgClassName?: string;
  color?: string;
};

const KTSVG: React.FC<Props> = ({
  className = "",
  path,
  svgClassName = "mh-50px",
  color,
}) => {
  return (
    <span
      className={`svg-icon ${className}`}
      style={{
        color: color,
      }}
    >
      <SVG src={toAbsoluteUrl(path)} className={svgClassName} />
    </span>
  );
};

export { KTSVG };
